<template>
  <div class="app">
    <NavBar slot="nav" active="index" />
    <div class="content">
      <img src="./img/banner.png" class="banner" alt="" />
      <div class="object">
        <div class="object_content">
          <div class="title">
            <div>人才培养服务模式</div>
            <div class="english_title">
              PERSONNEL TRAINING SERVICE MODE
            </div>
          </div>
          <div class="main">
            <div class="left">
              <div>
                <img src="./img/object_one.png" class="object_one" alt="" />
                <img src="./img/object_two.png" class="object_two" alt="" />
              </div>
              <img src="./img/object_three.png" class="object_three" alt="" />
              <img src="./img/object_line.png" alt="" class="object_line" />
            </div>
            <div class="right">
              <div>引领市场的人才培养体系；</div>
              <div>
                * 实战经验丰富的师资力量；
              </div>
              <div>* 科学合理的教学质量评价体系;</div>
              <div>* “职通车”赋能打开产业专业化人出口；</div>
              <div>* 持续赋能全职业生涯发展；</div>
              <div>
                * 积极探索推出加快健康人才培养的新路径、新模式、新标准和新方法。
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="service" ref="service">
        <div class="service_content">
          <div class="title">
            <div>智能在线学习平台</div>
            <div class="english_title">
              INTELLIGENT ONLINE LEARNING PLATFORM
            </div>
          </div>
          <div class="ul">
            <div
              v-for="(item, index) in serviceIconList"
              :key="index"
              :style="{ animationDelay: (index + 1) * 0.4 + 's' }"
              class="li"
              :class="serviceIsScroll ? 'animation' : ''"
            >
              <div class="circle">
                <img :src="item.src" class="icon" alt="" />
                <img
                  :src="
                    index % 2 === 0
                      ? require('./img/odd_arrows.png')
                      : require('./img/even_arrows.png')
                  "
                  class="line"
                  :class="index % 2 === 0 ? 'odd' : 'even'"
                  v-if="index !== serviceIconList.length - 1"
                />
              </div>

              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="service_advantage">
        <div class="service_advantage_content">
          <div class="title">
            <div>服务优势</div>
            <div class="english_title">
              SERVICE ADVANTAGES
            </div>
          </div>
          <div class="ul">
            <div
              class="li"
              v-for="(item, index) in serviceAdvantageList"
              :key="index"
              @mouseenter.stop="serviceAdvantageMouseenter(index)"
              @mouseleave.stop="serviceAdvantageMousemove"
            >
              <div class="img">
                <img :src="item.src" alt="" />
                <div v-if="serviceAdvantageCurrent !== index"></div>
              </div>

              <div class="name">{{ item.name }}</div>
              <span>{{ item.text1 }}</span
              ><span v-if="item.text2">{{ item.text2 }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="will_get">
        <div class="will_content">
          <div class="title">
            <div>你将得到</div>
            <div class="english_title">
              YOU WILL GET
            </div>
          </div>
          <div class="ul">
            <div class="li" v-for="(item, index) in willGetList" :key="index">
              <div
                class="top"
                :class="willGetCurrent === index ? 'active' : ''"
                @mouseenter.stop="willGetMouseenter(index)"
                @mouseleave.stop="willGetMouseleave"
              >
                <img
                  :src="
                    willGetCurrent === index ? item.srcActive : item.srcGray
                  "
                  alt=""
                />
              </div>
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="general">
        <div class="general_content">
          <div class="title">
            <div>大势所趋</div>
            <div class="english_title">
              THE TREND OF THE TIMES
            </div>
          </div>
          <div class="text">
            <div class="left">
              <div class="num">8万亿</div>
              <span
                >国务院印发的《“健康中国2030”规划纲要》中指出，到2020年，健康服务业总规模将超过8万亿元人民币，前景一片大好。</span
              >
            </div>
            <div class="middle"></div>
            <div class="right">
              <div class="num">3000万</div>
              <span
                >在未来5-10年，我国约需3000万健康服务产业人员，而目前的健康服务产业人员仅有15万，且专业性严重缺失。</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="begin">
        <div class="begin_content">
          <div class="title">
            <div>现在开始吧</div>
            <div class="english_title">HERE <span>WE</span> GO</div>
          </div>
          <div class="code">
            <div class="left">
              <img src="./img/phone.png" class="phone" alt="" />
              <div class="ercode" :class="beginFlag ? 'scale' : ''">
                <img :src="orgInfo.qrCode" alt="" />
              </div>
            </div>
            <div class="line"><img src="./img/phone_line.png" alt="" /></div>
            <div class="right">
              <div
                @mouseenter.stop="beginMouseEnter"
                @mouseleave="beginMouseleave"
              >
                微信扫码，使用小程序学习
              </div>
              <div @click="toStudy">点击这里，使用网站学习</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer slot="footer" class="footer" />
  </div>
</template>

<script>
import Mixin from "./mixin.js";
import Storage from "good-storage";
export default {
  mixins: [Mixin],
  name: "app",
  data() {
    return {
      orgInfo: Storage.session.get("ORG_INFO") || {}
    };
  },
  mounted: function() {},
  beforeDestroy: function() {},
  components: {}
};
</script>
<style lang="scss">
@import "../../assets/style/var.scss";
@import "./css/index.scss";
</style>
